/** Joining the middot-separated notes that label a section.
 *
 *  `['READ-ONLY', '7 EVENTS', 'STALE'].join(' · ')` breaks at the space *before*
 *  a `·`, so a wrapped note can start a line with a lone middot — which in this
 *  design language is the open-task signifier, and reads as a stray entry. A
 *  non-breaking space before each separator moves the break after the dot.
 */
export const NOTE_SEPARATOR = '\u00a0· ';

export function noteList(parts: (string | null | undefined)[]): string {
  return parts.filter((p): p is string => Boolean(p)).join(NOTE_SEPARATOR);
}
